import "./TopSubNavBar.css";

const TopSubNavBar = ({ topTab, subTab, selectSubTab, tabList }) => {
  const activeTab = tabList.find((tab) => tab.name === topTab);
  const subTabList = activeTab?.subTabList ?? [];

  // 하위 메뉴가 없는 상단 메뉴에서는 줄 자체를 두지 않는다(밑줄만 남으면 어색하다).
  if (subTabList.length === 0) {
    return null;
  }

  return (
    <div className="teacher-sub-nav">
      <div className="teacher-sub-nav__inner">
        {subTabList.map((subTabItem) => (
          <span
            key={subTabItem.name}
            className={`teacher-sub-nav__tab${
              subTab === subTabItem.name ? " teacher-sub-nav__tab--active" : ""
            }`}
            onClick={() => selectSubTab(subTabItem.name)}
          >
            {subTabItem.text}
            {subTabItem.badge && (
              <span className="teacher-sub-nav__beta">✨ {subTabItem.badge}</span>
            )}
          </span>
        ))}
      </div>
    </div>
  );
};

export default TopSubNavBar;
